<template>
  <div class="overflow-hidden">
    <header-help :is-loading="isLoading"></header-help>

    <section class="cp-page">
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container mt-5 position-relative" style="z-index: 1;">
        <global-message></global-message>
        <div class="row">
          <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="cp-content-card p-4">
              <div class="text-center py-4">
                <img src="@/assets/images/congrets.png" style="width: 80px; height: 80px;">
                <h1 class="text-white font-weight-bold mt-3">Awesome!</h1>
                <h5 class="font-size-16 text-white mt-2">You donated ${{ amount }} to {{ invitee.urlSuffix }}!</h5>
                <p class="font-size-14 mt-3" style="color: rgba(255,255,255,0.6);">
                  @{{ invitee.urlSuffix }} has been notified of your generous donation and support!
                </p>
                <div style="white-space: nowrap;" class="font-weight-600 py-3 text-white">@{{ invitee.name }}</div>
              </div>

              <div class="text-center mt-4">
                <button type="button"
                  class="cp-btn-primary px-5 py-3"
                  @click="finish()">Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {mapActions} from 'vuex';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {igValidationMixin} from "@/mixin/ig-validation-mixin";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import titleMixin from "../../../../mixin/title-mixin";
import {paymentPaid, TIP} from "@/common/analytics-service";

export default {
  name: 'CustomerTipComplete',
  title: 'Customer tip complete',
  mixins: [igValidationMixin, customerAccountMixin, titleMixin],
  components: {GlobalMessage, LoadingModal, HeaderHelp},
  data() {
    return {
      invitee: {},
      amount: '',
    }
  },
  created() {
    this.invitee = this.getInvitee;
    this.amount = localStorage.getItem('tip');
    this.setMessage('PAYMENT.SUCCESSFUL');
  },
  mounted() {
    paymentPaid(this, TIP, this.invitee);
  },
  methods: {
    ...mapActions(['setMessage']),
    finish() {
      let donate = this.$route.query.donate;
      if (this.getCreatePlatform || donate) {
        this.showCustomerContent();
      } else {
        this.$router.replace({name: 'CreateAccountComplete'});
      }
    }
  }
}
;
</script>